<script>
import logo from '@/assets/logo.png'

export default {
  name: 'MyHeader',
  data(){
    return{
      name: "",
      logo: logo
    }
  },
  created: function () {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      try {
        this.name = JSON.parse(userInfo).name
      } catch (e) {
        console.error('解析用户信息失败', e)
      }
    }
  },
  methods:{
    logout(){
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$router.push("/login")
    }
  }
}

</script>

<template>
  <div class="header-container">
    <div class="header-left">
      <img :src="logo" alt="Mild插件" class="header-logo">
      <h1 class="header-title">Mild云端插件开发管理系统</h1>
    </div>
    <div class="header-right">
      <el-dropdown trigger="click" class="user-dropdown">
        <div class="user-info">
          <div class="user-avatar">
            <i class="el-icon-user-solid"></i>
          </div>
          <span class="user-name" v-if="name && name.trim() !== ''">{{name}}</span>
          <span class="user-name" v-else>暂无用户</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="name && name.trim() !== ''">{{name}}</el-dropdown-item>
          <el-dropdown-item v-else>暂无用户</el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 60px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.header-container:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-logo {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.header-logo:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
  transition: all 0.3s ease;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-dropdown {
  cursor: pointer;
  transition: all 0.3s ease;
}

.user-dropdown:hover {
  transform: translateY(-1px);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: #f5f7fa;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-icon-arrow-down {
  font-size: 12px;
  color: #999;
  transition: all 0.3s ease;
}

.user-dropdown:hover .el-icon-arrow-down {
  transform: rotate(180deg);
  color: #667eea;
}

/* 下拉菜单样式 */
::v-deep .el-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: none;
  overflow: hidden;
}

::v-deep .el-dropdown-menu__item {
  padding: 10px 16px;
  transition: all 0.3s ease;
}

::v-deep .el-dropdown-menu__item:hover {
  background: #f5f7fa;
  color: #667eea;
}

::v-deep .el-dropdown-menu__item.divided {
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
  padding-top: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-container {
    padding: 0 16px;
  }
  
  .header-title {
    font-size: 16px;
  }
  
  .user-name {
    display: none;
  }
  
  .user-info {
    padding: 8px;
  }
}
</style>